import { fetchRS } from "../utils/fetchRS";

export const getTinas = (objectBody: any) =>
  fetchRS(`${process.env.REACT_APP_API_URL}/tina/all`, {
    method: "POST",
    objectBody,
  });
export const getTina = (id: number) =>
  fetchRS(`${process.env.REACT_APP_API_URL}/tina/${id}`);

export const savetTina = (objectBody: any) =>
  fetchRS(`${process.env.REACT_APP_API_URL}/tina/`, {
    method: "PUT",
    objectBody,
  });

  export const deleteTina = (id: number) =>
    fetchRS(`${process.env.REACT_APP_API_URL}/tina/delet/${id}`,
  {
    method: "DELETE",
  });